import React, { Component } from 'react'
import { Spinner } from 'react-bootstrap';
import Styles from '../../Css/Hotspot/Hotspot.module.css'

export default class HotSpotChildComponentLoading extends Component {

    render() {
        return (
            <section className={[Styles['hotSpotChildComponentLoadingConatainer']]}>
                <Spinner animation="border" variant="warning"/>
            </section>
        )
    }
}
